import arrayToTree from "array-to-tree";
import { listDept } from "@/api/dept.js"

export default {
    state: {
        deptList: [],
        deptTree: [],
    },

    mutations: {
        setDeptList: (state, data) => {
            state.deptList = data;
        },
        setDeptTree: (state, data) => {
            state.deptTree = data;
        },
    },

    actions: {
        getDeptList({ commit, state }, data) {
            return new Promise((resolve, reject) => {
                if (state?.deptList?.length) {
                    resolve(state.deptList)
                } else {
                    listDept(data).then(res => {
                        if (res.code == 200 && res?.data?.length) {
                            for (let i = 0; i < res.data.length; i++) {
                                const element = res.data[i];
                                element.value = element.deptId
                                element.text = element.deptName
                            }
                            const _dept_tree = arrayToTree(res.data, { parentProperty: "parentId", customID: "deptId" })
                            commit("setDeptList", res.data)
                            commit("setDeptTree", _dept_tree)
                        }
                        resolve(res.data)
                    }).catch(err => {
                        reject(err)
                    })
                }
            })
        },
    }
}
